// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

export default {
  options: function options(h, conf, key) {
    var list = [];
    conf.__slot__.options.forEach(function (item) {
      if (conf.__config__.optionType === 'button') {
        list.push(h("el-radio-button", {
          "attrs": {
            "label": item.value
          }
        }, [item.label]));
      } else {
        list.push(h("el-radio", {
          "attrs": {
            "label": item.value,
            "border": conf.border
          }
        }, [item.label]));
      }
    });
    return list;
  }
};